// extracted by mini-css-extract-plugin
module.exports = {"title":"ConsentItem_title__33ek6","titleWithdrawn":"ConsentItem_titleWithdrawn__d2U4j","date":"ConsentItem_date___Wz00","container":"ConsentItem_container__1nQ33"};